export const BreakTypesEnum = {
    Lunch: 'LUNCH',
    Refuel: 'REFUEL',
    Night: 'NIGHT',
    Other: 'OTHER'
};
